import Modal from '@common/ModalPopup';
import React, { useEffect, useState } from 'react';
import * as HELPER from '@src/config/helper';
import { ROLE_FEATURES, STATUS_SUCCESS } from '@src/config/constant';
import { toast } from 'react-toastify';
import FinancierService from '@src/services/FinancierService';
import { Financier } from './financiers.interface';

export default function AddEditFinancier(props: any): ReturnType<React.FC> {
    let { showAddFinancier, showModalAddFinancier, callFrom, selectedFinancier, handleLoader, tableData, setTableData, getFinanciersList } = props;    
    let [previewImageLogo, setPreviewImageLogo] = useState<string>("images/upload_icn.svg");
    let [selectedInput, setSelectedInput] = useState<{ name: string }>({ name: '' });
    let [logo, setLogo] = useState<File | undefined>(undefined);
    let [errors, setErrors] = useState<Record<string, boolean>>({});

    useEffect(() => {
        if (callFrom === 'EditFinancier') {            
            setPreviewImageLogo(selectedFinancier?.logo ?? "images/upload_icn.svg");
            setSelectedInput((prev) => ({
                ...prev,
                name: selectedFinancier?.name
            }));
        }
    // eslint-disable-next-line
    }, [showAddFinancier])

    //Handles the closing of the Add/Edit Financier modal.
    const handleClose = () => {
        setLogo(undefined);
        setPreviewImageLogo("images/upload_icn.svg");
        setSelectedInput({ name: '' });
        showModalAddFinancier();
        setErrors({});
    }

    /**
     * Handles the file input change event, processes the selected file, and performs validation checks.
     * @param e - The event object from the file input change event.
     */
    const handleFileInputChange = async (name: string, e: React.ChangeEvent<HTMLInputElement>) => {

        if (name === 'logo') {
            let selectedFile = e.target?.files;

            if (selectedFile && selectedFile.length > 0) {
                let base64PreviewImg = await HELPER.toBase64(selectedFile[0])
                let filetype = await HELPER.detectMimeType(base64PreviewImg)
                let fileSize = selectedFile[0].size


                if (!filetype) {
                    toast.error("Please Select A Valid File")
                    e.target.value = ''
                    return
                }

                else if (fileSize < 25000 || fileSize > 5000000) {
                    toast.error('file size should be between 25kb to 5mb')
                    e.target.value = ''
                    return
                }
                setPreviewImageLogo(base64PreviewImg as string);
                setLogo(selectedFile[0]);
            }
        } else {
            setSelectedInput((prev) => ({
                ...prev,
                [name]: e.target.value
            }));
        }
    }

    /**
     * Handles the submission of the financier form.
     * Constructs the API parameters using the selected input values
     * and sends a request to add a new financier using the FinancierService.
     *
     * @async
     * @function handleSubmit
     * @returns {Promise<void>} A promise that resolves when the financier is successfully added.
     */
    const handleSubmit = async (): Promise<void> => {   
        let errorExists = checkValidation()

        //if validation error
        if (errorExists) {
            return;
        }
        handleLoader(true);     
        type ApiParamsType = { name: string };

        let apiParams: ApiParamsType = {
            name: selectedInput.name.trim(),
        };

        //preparing form data
        let formData = new FormData();

        for (let key in apiParams) {
            let value = apiParams[key as keyof ApiParamsType]

            if (typeof (value) == 'object') {
                formData.append(key, JSON.stringify(value))
            }
            else {
                formData.append(key, value)
            }
        }

        if (logo instanceof File) {
            formData.append('logo', logo);
        }

        let savePartnerMsg: string = "Financier Created Successfully";

        if(callFrom === 'EditFinancier') {
            formData.append('id', selectedFinancier?.id );
            savePartnerMsg = "Data Updated Successfully";
        }

        const response = await FinancierService.addFinancier(formData);        
        
        if(response.status === STATUS_SUCCESS) {
            toast.success(savePartnerMsg);

            if(callFrom === 'EditFinancier') {
                const { name, logo, id } = response?.data?.data;  
                //update the table data with the new financier
                const updatedTableData = tableData?.map((item: Financier) => {
                    if (item.id === id) {                    
                        return {
                            ...item,
                            ...(logo && { logo: logo }),
                            ...(name && { name: name }),
                        };
                    }
                    return item;
                });            
                setTableData(updatedTableData);
            }else{
                await getFinanciersList();
            }

            handleClose()
        }else {            
            toast.error(response?.data?.message ?? "Error while adding financier");
        }
        handleLoader(false);
    }

    /**
     * Checks the validation of the selected input fields.
     * @returns {boolean} - Returns true if there are validation errors, false otherwise.
     */
    const checkValidation = () => {
        let errorExists = false;

        for (let key in selectedInput) {
            let value = selectedInput[key as keyof typeof selectedInput]
            if (key === 'name' && value.trim() === '') {
                setErrors((prev) => ({
                    ...prev,
                    [key]: true
                }));
                errorExists = true;
                break;
            }
        }

        return errorExists;
    }


    return (
        <div className="Add-Financer-popup bankdetail-popup">
            <Modal show={showAddFinancier ?? false} handleClose={handleClose} >
                <div className="modal-header">

                    <h2>{callFrom === 'AddFinancier' ? "Add New Financier" : "Edit Financier"}</h2>
                </div>

                <div className="modal-body" >

                    <div className="row">
                        <div className='col-md-6'>
                            <div className='row'>
                                <fieldset className="form-select-bx col-md-12 w-100">
                                    <div className="material">
                                        <input id=""
                                            type="text"
                                            placeholder=" "
                                            name="financier_name"
                                            className="form-input"
                                            onChange={(e) => handleFileInputChange('name', e)}
                                            value={selectedInput['name']}
                                        />
                                        <label data-label="Financier Name *" className="form-label"></label>
                                        {
                                            errors && errors.name
                                                ?
                                                <span className="error-txt">{"This field is Required"}</span>
                                                :
                                                ''
                                        }
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div className="img-bx-select-opt col-md-6">

                            <div className="image-bx more-file-upload add-insurance-partner">
                                {
                                    <>
                                        <img src={previewImageLogo} alt={"uploadImage"} className="upload-icn" />
                                        <input
                                            type="file"
                                            name="image"
                                            id="upload-image-input"
                                            className="upload-box"
                                            accept="image/*"
                                            onChange={(e) => handleFileInputChange('logo', e)} />
                                        <p>Upload Photo</p>

                                    </>
                                }
                                <label data-label="Financier Logo" className="form-label insurance-partner-logo">Financier Logo</label>
                            </div>

                        </div>
                    </div>
                    {

                        HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_partner_management'], accessType: 'edit' }) &&
                        <button className="btn-primary" onClick={handleSubmit}>
                            Save
                        </button>
                    }

                </div>
            </Modal>
        </div>
    );
}